import { UserModel } from "interfaces/user";

export const filterString = (
    items: any[],
    value: string | undefined,
    fields: string[]
) => {
    if (!value) return items;

    return items.filter((item) => {
        let isValid = false;
        for (const field of fields) {
            const includes = String(item[field])
                .toLowerCase()
                .includes(value.toLowerCase());
            const startsWith = String(item[field])
                .toLowerCase()
                .startsWith(value.toLowerCase());
            if (includes || startsWith) {
                isValid = true;
            }
        }

        return isValid;
    });
};

export const filterCompany = (user: UserModel) => {
    if (!user.internal_group?.length) return undefined;

    return user.internal_group.map((group: any) => Number(group.id_syscambio));
};


export const filterGroup = (user: UserModel) => {
    if (!user.internal_group?.length) return undefined;

    const list: number[] = [];

    user.internal_group.forEach((data: any) => {
        if (data.group && data.group.length) {
            data.group.forEach((groupItem: any) => {
                const groupId = Number(groupItem.id_syscambio);
                if (!list.includes(groupId)) {
                    list.push(groupId);
                }
            });
        }
    });
    return list.length ? list : undefined;
};
